import CategoryPageShell from "../../../components/workspace/CategoryPageShell";
import ShiftKitSection from "../../../components/workspace/ShiftKitSection";

export default function ShiftKit() {
  return (
    <CategoryPageShell
      testId="pcc-category-shift-kit"
      slug="shift-kit"
      eyebrow="Shift Kit"
      title="Your everyday on-shift forms."
      description="Start of shift, during the shift, if something happens, end of shift, and protecting yourself — all in one place."
    >
      <ShiftKitSection />
    </CategoryPageShell>
  );
}
